import React from 'react';

import { GridLayout, GridLayoutItem } from 'components/grid/GridLayout';

import s from './PowerStationStats.module.scss';

type Props = { children?: React.ReactNode };

export const PowerStationStats = ({ children }: Props) => {
  return (
    <div className={s.powerStationStats}>
      <GridLayout>
        <GridLayoutItem
          className={s.powerStationStats__container}
          offset={{ desktop: 2 }}
          columns={{ desktop: 10 }}
        >
          {children}
        </GridLayoutItem>
      </GridLayout>
    </div>
  );
};
